import React, { Component } from "react";
import { Table, Button, Modal, Row, Col, Tooltip, message, Icon, Select } from "antd";
import axios from "axios";
import "./Pages.css";
import AnaliseProducaoForm from '../components/AnaliseProducaoForm';
import OrdemProducaoPedidosForm from '../components/OrdemProducaoPedidosForm';
import AnaliseProducaoOPForm from '../components/AnaliseProducaoOPForm';
import FiltrosForm from '../components/FiltrosForm';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao, getTipoUsuario, getEmpresa } from "../utils/LoginManager";
import InputForm from "../components/InputForm";
import Colors from "../utils/Colors";


const dateFormat = 'DD/MM/YYYY'
const { Column } = Table;
const ButtonGroup = Button.Group;
const { Option } = Select;


export const OPCOES_STATUS = [
  { key: 1, label: 'PENDENTE' },
  { key: 2, label: 'FINALIZADO' },
]


export default class extends Component {
  state = {
    listaRegistros: [],
    registro: '',
    eventStatus: '',
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeTotal: 0,
    qtdePend: 0,
    qtdeFin: 0,

    formVisivel: false,

    formFiltroVisivel: false,

    filtros: {
      tipoTela: 'AP',
      buscaOrdem: { campo: 'ap_data_fabricacao', ordem: 'DESC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    getEmpresa().then(codEmpresa => {
      getTipoUsuario().then(tipoUsuario => {
        this.state.filtros.buscaUsuario = {
          key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
        }
        this.setState({
          usuario,
          codEmpresa,
          tipoUsuario,
        }, this.getListaRegistros);
      })
    })
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true, qtdeTotal: 0, qtdePend: 0, qtdeFin: 0 });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaMunicipio,
      buscaOrdem } = this.state.filtros;

    let dt_ini = '';
    if ((buscaDataIni) && (buscaDataIni !== undefined)) {
      dt_ini = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }
    let dt_fim = '';
    if ((buscaDataFim) && (buscaDataFim !== undefined)) {
      dt_fim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
    }

    axios
      .get('/analiseProducao', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          numero: buscaControle,
          codCliente: buscaPessoa.key,
          cidade: buscaMunicipio.key,
          dt_ini,
          dt_fim,
          print: 0,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data.consulta;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),

          qtdeTotal: response.data.qtdeTotal,
          qtdePend: response.data.qtdePend,
          qtdeFin: response.data.qtdeFin,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregando: false,
        });
      });
  };





  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (registro.ap_idf) {
      request = axios.put(`/analiseProducao/update/${registro.ap_idf}`, registro);
    } else {
      request = axios.post(`/analiseProducao/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Produção gravada com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }

  onAdicionarClick = () => {
    axios.get('/analiseProducao/lista', {
      params: {
        mes: moment().format('MM'),
        ano: moment().format('YYYY'),
      }
    }).then(response => {
      this.setState({
        formVisivel: true,
        visualizar: false,
        registroSelecionado: {
          dados: {
            ap_idf: 0,
            ap_idf_pedido: 0,
            ap_idf_producao: 0,
            ap_usuario: { key: '0', label: '' },
            ap_cliente: { key: '0', label: '' },
            ap_produto: { key: '0', label: '' },
            ap_num_lote: moment().format('YY') + String(moment().week()).padStart(2, "0") + moment().format('DD'),
            ap_controle: String(moment().week()).padStart(2, "0") + String(parseInt(response.data.ap_controle ? response.data.ap_controle.slice(-3) : 0) + 1).padStart(3, "0"),
            ap_data_amostras: moment().format('DD/MM/YYYY'),
            ap_data_fabricacao: moment().format('DD/MM/YYYY'),
            ap_data_validade: moment().format('DD/MM/YYYY'),
            ap_dias_validade: 0,
            ap_qtde_producao: 0,
            ap_categoria: { key: '0', label: '' },
            ap_protocolo: '',
            ap_laboratorio: this.state.usuario.usu_nome,
            ap_obs: '',
            listaItens: [],
            visualizando: false,
          }
        },
      })
    }).catch(error => {
      console.error(error.response);
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  onEditarClick = (ap_idf) => {
    this.setState({ carregando: true });
    axios.get(`/analiseProducao/show/${ap_idf}`)
      .then(response => {
        const { data } = response;

        data.dados.ap_cliente = {
          key: String(data.dados.ap_cliente),
          label: data.dados.pes_nome,
        }
        data.dados.ap_produto = {
          key: String(data.dados.ap_produto),
          label: data.dados.prod_descricao,
        }
        data.dados.ap_protocolo = {
          key: String(data.dados.ap_protocolo),
          label: '',
        }
        data.dados.ap_categoria = {
          key: String(data.dados.ap_categoria),
          label: '',
        }
        data.dados.ap_data_amostras = moment(data.dados.ap_data_amostras, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.ap_data_fabricacao = moment(data.dados.ap_data_fabricacao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        data.dados.ap_data_validade = moment(data.dados.ap_data_validade, 'YYYY-MM-DD').format('DD/MM/YYYY');

        data.dados.visualizando = data.dados.ap_status === 2 ? true : false;

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir a análise de produção do cliente ${registro.pes_nome} ?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/analiseProducao/delete/${registro.ap_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.ap_idf === registro.ap_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };


  onImprimirClick = (ap_idf) => {

  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onBuscar = event => {
    event.preventDefault();
    this.getListaRegistros();
  }


  renderDataHora = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }






  renderStatus = (sit, registro) => {
    const ap_status = {
      key: String(sit),
      label: '',
    }
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          type="select"
          id="ap_status"
          ref="ap_status"
          value={ap_status}
          placeholder="Status"
          onChange={situacao => this.onChangeStatus(registro, situacao)}
          data={OPCOES_STATUS}
          validator={value => Boolean(value)}
          style={{ width: 150 }}
        />
      </Col>
    );
  };



  onChangeStatus = (registro, event) => {
    this.setState({ carregando: true })
    axios.
      put(`/analiseProducao/updateStatus/${registro.ap_idf}/${event.target.value.key}`)
      .then(response => {
        registro.ap_status = parseInt(event.target.value.key);
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          registro: '',
          eventStatus: '',
          carregando: false,
          qtdeFin: (parseInt(event.target.value.key) === 1 ? this.state.qtdeFin - 1 : this.state.qtdeFin + 1),
          qtdePend: (parseInt(event.target.value.key) === 2 ? this.state.qtdePend - 1 : this.state.qtdePend + 1)
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };








  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">

        {getTemPermissao('AnaliseProducaoPage', 'editar') ? (
          <Tooltip title={registro.ap_status === 2 ? "Visualizar" : "Editar"}>
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro.ap_idf)} icon={registro.ap_status === 2 ? "eye" : "edit"} />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro.ap_idf, false)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('AnaliseProducaoPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={registro.ap_status === 2 ? true : false} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : (
          <Tooltip title="Excluir">
            <Button className="botoesModalFormExcluir" size="small" disabled={true} onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        )}
        <Tooltip title="Imprimir Análise">
          <Button type="default" size="small" onClick={() => this.onImprimirClick(registro.ap_idf, false)} icon="printer" />
        </Tooltip>

      </ButtonGroup>
    );
  };


  renderCliente = (usu_nome) => {
    return (
      <span style={{ fontSize: 11 }}>{usu_nome}</span>
    );
  };

  renderCidade = (cmun_descricao, registro) => {
    return (
      <span>{cmun_descricao} - {registro.cuf_sigla}</span>
    );
  };

  renderOrigem = (origem, registro) => {
    return (
      <span>{registro.pi_idf_venda ? 'Pedido' : 'Manual'}</span>
    );
  };



  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaAgruparCidades: this.state.filtros.buscaAgruparCidades,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };







  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })



  onFecharModalPedidosClick = () => {
    this.setState({
      modalPedidosVisible: false,
    }, this.getListaRegistros);
  }

  onFecharModalPedidosAbrirFormClick = (ap_idf) => {
    this.setState({
      modalPedidosVisible: false,
    });
    this.onEditarClick(ap_idf);
    this.getListaRegistros();
  }

  onNovoPedidos = (event) => {
    this.setState({
      modalPedidosVisible: true,
      registroSelecionadoPedido: {
        selectedRowKeys: [],
        visualizando: true,
      },
    });
  }



  onFecharModalOrdemProducaoClick = () => {
    this.setState({
      modalProducaoVisible: false,
    }, this.getListaRegistros);
  }

  onFecharModalOrdemProducaoAbrirFormClick = (ap_idf) => {
    this.setState({
      modalProducaoVisible: false,
    });
    this.onEditarClick(ap_idf)
    this.getListaRegistros()
  }

  onNovoOrdemProducao = (event) => {
    this.setState({
      modalProducaoVisible: true,
      registroSelecionadoProducao: {
        selectedRowKeys: [],
        visualizando: true,
      },
    });
  }









  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado, filtros, registroSelecionadoPedido, registroSelecionadoProducao,
      total, pagina, limite, formFiltroVisivel, modalPedidosVisible, modalProducaoVisible } = this.state;

    // console.log('AnaliseProducaoPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Análise Laboratorial da Produção</h2>
        <hr />
        <br />

        <div className="pageFiltro" style={{ height: 70 }}>
          <Row>
            <Col xs={12} style={{ marginTop: -5 }}>
              {(!this.state.tipoUsuario) || (getTemPermissao('AnaliseProducaoPage', 'novo')) ? (
                <span>
                  <Tooltip title="Nova Análise Laboratorial Avulsa">
                    <Button
                      onClick={this.onAdicionarClick}
                      className="pageFiltro-adicionar"
                    >
                      Adicionar
                    </Button>
                  </Tooltip>

                  <Tooltip title="Nova Análise Laboratorial dos Pedidos">
                    <Button
                      onClick={this.onNovoPedidos}
                      className="pageFiltro-adicionar"
                    >
                      Pedidos
                    </Button>
                  </Tooltip>

                  <Tooltip title="Nova Análise Laboratorial das Ordens de Produção">
                    <Button
                      onClick={this.onNovoOrdemProducao}
                      className="pageFiltro-adicionar"
                    >
                      Produção
                    </Button>
                  </Tooltip>
                </span>
              ) : null}

              <Button
                onClick={this.onAbrirFiltroClick}
                className="pageFiltro-filtrar"
                style={{ marginRight: 15 }}
              >
                Filtrar
              </Button>

              <FiltrosForm
                visivel={formFiltroVisivel}
                onFiltrarClick={this.onFiltrarClick}
                onCancelarFiltroClick={this.onCancelarFiltroClick}
                filtros={filtros}
              />

              <OrdemProducaoPedidosForm
                visivel={modalPedidosVisible}
                onSalvarPedidosClick={this.onSalvarPedidosClick}
                onFecharModalPedidosClick={this.onFecharModalPedidosClick}
                onFecharModalPedidosAbrirFormClick={this.onFecharModalPedidosAbrirFormClick}
                registroSelecionadoPedido={registroSelecionadoPedido}
                tipoTela='AP'
              />

              <AnaliseProducaoOPForm
                visivel={modalProducaoVisible}
                onSalvarPedidosClick={this.onSalvarPedidosClick}
                onFecharModalOrdemProducaoClick={this.onFecharModalOrdemProducaoClick}
                onFecharModalOrdemProducaoAbrirFormClick={this.onFecharModalOrdemProducaoAbrirFormClick}
                registroSelecionadoProducao={registroSelecionadoProducao}
                tipoTela='AP'
              />

            </Col>


            <Col xs={24} sm={12} style={{ marginTop: -15 }}>
              <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Total</span></Row>
                <Row><span>{this.state.qtdeTotal}</span></Row>
              </Col>
              <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Pendente</span></Row>
                <Row><span>{this.state.qtdePend}</span></Row>
              </Col>
              <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                <Row><span style={{ fontWeight: "bold" }}>Finalizado</span></Row>
                <Row><span>{this.state.qtdeFin}</span></Row>
              </Col>
            </Col>

          </Row>

          <AnaliseProducaoForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

        </div>



        <div style={{ marginTop: -30 }}>
          <Table
            pagination={{
              total: total,
              pageSize: limite,
              current: pagina,
              pageSizeOptions: ['10', '20', '30', '40', '50'],
              showSizeChanger: true,
            }}
            onChange={this.onTabelaChange}
            loading={{
              spinning: carregando,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            // scroll={{ x: 600 }}
            rowKey={(registro => registro.ap_idf)}
          >
            {/* <Column
              key="ap_data_amostras"
              dataIndex="ap_data_amostras"
              title={this.renderTitulo("Amostra")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"8%"}
              align="center"
              className="listaCadastro"
            /> */}
            <Column
              key="ap_data_fabricacao"
              dataIndex="ap_data_fabricacao"
              title={this.renderTitulo("Fabricação")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"8%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_data_validade"
              dataIndex="ap_data_validade"
              title={this.renderTitulo("Validade")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderData}
              width={"8%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_qtde_producao"
              dataIndex="ap_qtde_producao"
              title={this.renderTitulo("Qtde")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="ap_peso_real"
              dataIndex="ap_peso_real"
              title={this.renderTitulo("Peso")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="right"
              className="listaCadastro"
            />
            <Column
              key="ven_numero"
              dataIndex="ven_numero"
              title={this.renderTitulo("Pedido")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="op_numero"
              dataIndex="op_numero"
              title={this.renderTitulo("O.P")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_num_lote"
              dataIndex="ap_num_lote"
              title={this.renderTitulo("Lote")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="ap_controle"
              dataIndex="ap_controle"
              title={this.renderTitulo("Controle")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="pes_nome"
              dataIndex="pes_nome"
              title={this.renderTitulo("Cliente")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderCliente}
              width={"8%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title={this.renderTitulo("Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"5%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title={this.renderTitulo("Descrição Produto")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              width={"12%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="ap_status"
              dataIndex="ap_status"
              title={this.renderTitulo("Status")}
              onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
              render={this.renderStatus}
              width={"10%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>Ações</div>}
              render={this.renderAcoes}
              width={"20%"}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/AnaliseProducaoPage.js